var render = function render(){var _vm=this,_c=_vm._self._c;return _c('menu-layout',[_c('row',[_vm._v(" Something went wrong. "),_c('br'),_c('a',{attrs:{"href":"/"}},[_vm._v("Go back to home page")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }